import {useState} from 'react';
import {Card, CardContent, CardHeader, CardTitle} from '@/components/ui/card.tsx';
import {Button} from '@/components/ui/button.tsx';
import {PencilIcon} from '@heroicons/react/24/outline';
import {CustomerDetails} from '@/store/customerFile.ts';
import {EditCustomerDetailsModal} from './EditCustomerDetailsModal.tsx';

interface Props {
    customer: CustomerDetails;
    canEdit: boolean;
}

function InfoRow({label, value}: {label: string; value?: string | null}) {
    if (!value) return null;
    const isLtr = /^[A-Za-z0-9]/.test(value);
    return (
        <div className="flex flex-col sm:flex-row sm:items-center gap-0.5 sm:gap-2">
            <span className="text-xs text-gray-400 w-28 shrink-0">{label}</span>
            <span className="text-sm text-gray-800 font-medium" dir={isLtr ? 'ltr' : undefined}>{value}</span>
        </div>
    );
}

export function CustomerFileInfoCard({customer, canEdit}: Props) {
    const [editOpen, setEditOpen] = useState(false);

    return (
        <>
            <Card>
                <CardHeader className="pb-3">
                    <div className="flex items-center justify-between">
                        <CardTitle className="text-base">פרטי תיק לקוח</CardTitle>
                        {canEdit && (
                            <Button variant="ghost" size="icon" onClick={() => setEditOpen(true)}>
                                <PencilIcon className="w-4 h-4" />
                            </Button>
                        )}
                    </div>
                </CardHeader>
                <CardContent className="space-y-2.5">
                    <InfoRow label="שם הארגון" value={customer.business_name} />
                    <InfoRow label="שם איש קשר" value={customer.contact_name} />
                    <InfoRow label="מייל ראשי" value={customer.email} />
                    <InfoRow label="שם לקבלה" value={customer.receipt_name} />
                    <InfoRow label="מייל לקבלה" value={customer.receipt_email} />
                    <InfoRow label="טלפון" value={customer.phone} />
                    <InfoRow label="טלפון 2" value={customer.phone2} />
                    <InfoRow label="פקס" value={customer.fax} />
                </CardContent>
            </Card>

            {editOpen && (
                <EditCustomerDetailsModal
                    open={editOpen}
                    onClose={() => setEditOpen(false)}
                    customer={customer}
                />
            )}
        </>
    );
}
